export default {
    root: {
        '& .SVGInline': {
            height: 12,
            transition: 'transform 0.3s ease-in',
            marginLeft: "8px"
        }
    },
    firstCell: {
        display: 'flex',
        alignItems: 'center',
        flex: 1,
        maxWidth: 120,
        '& .md-checkbox > span::before': {
            marginRight: 22
        }
    },
    firstCellSelectedHeader: {
        display: 'flex',
        alignItems: 'center',
        '& .md-checkbox > span::before': {
            marginRight: 22
        }
    },
    cell: {
        maxWidth: 240,
        overflowX: 'hidden',
        flex: 1,
        textOverflow: 'ellipsis',
        '& span':{
            paddingLeft : "1px"
        },
        '&:nth-child(2)': {
            paddingLeft: 6,
        }
    }, 
    disabledCell: {
        color: '#97A3B7'
    },
    headerRowSelected: {
        textTransform: 'initial !important',
        fontSize: 14,
        justifyContent: 'flex-start',
        '& .h-tcell': {
            flexGrow: 0,
            maxWidth: 'initial',
            paddingTop: '3px'
        }
    },
    headerRow: {
        justifyContent: "normal",
        '& .SVGInline > svg': {
            height: 10
        },
        '& .SVGInline': {
            opacity: 0
        }, 
        '& .SVGInline.active': {
            opacity: 0.4
        },
        '&:hover .SVGInline.active': {
            opacity: 1
        },
        '&:hover .SVGInline': {
            opacity: 0.4
        }
    },
    cellCenter: {
        textAlign: 'center'
    },
    cellEnd: {
        textAlign: 'end'
    },
    actionBtn: {
        cursor: 'pointer',
        textDecoration: 'underline',
        textTransform: 'capitalize',
        display: 'flex',
        alignItems: 'center',
        '& .SVGInline': {
            marginRight: 8,
            height: 16
        }
    },
    row: {
        userSelect: 'none',
        height: 52,
        justifyContent: "normal",
        '&:hover': {
            '& .primaryUserButton': {
                display: 'inline-flex'
            }
        }
    },
    avatar: {
        marginLeft: 0
    },
    smAppContainer : {
        paddingLeft : "30px"
    }
}